module.exports = __webpack_public_path__ + "img/s-green.4695b847.svg";